import { BaseModal } from './BaseModal'
import { SettingsToggle } from './SettingsToggle'
import {
  HARD_MODE_DESCRIPTION,
  HIGH_CONTRAST_MODE_DESCRIPTION,
} from '../../constants/strings'
import { useLocation, useNavigate } from 'react-router-dom'

type Props = {
  isOpen: boolean
  handleClose: () => void
  isHardMode: boolean
  handleHardMode: Function
  isDarkMode: boolean
  handleDarkMode: Function
  isHighContrastMode: boolean
  handleHighContrastMode: Function
}

export const SettingsModal = ({
  isOpen,
  handleClose,
  isHardMode,
  handleHardMode,
  isDarkMode,
  handleDarkMode,
  isHighContrastMode,
  handleHighContrastMode,
}: Props) => {
  const routerLocation = useLocation()
  const navigate = useNavigate()
  const isPracticeMode = routerLocation.pathname === '/practice'

  const handlePracticeMode = (enabled: boolean) => {
    handleClose()
    navigate(enabled ? '/practice' : '/')
  }

  return (
    <BaseModal title="Settings" isOpen={isOpen} handleClose={handleClose}>
      <div className="flex flex-col mt-2 divide-y">
        <SettingsToggle
          settingName="Endless Mode"
          flag={isPracticeMode}
          handleFlag={handlePracticeMode}
          description="Play unlimited random words"
        />
        <SettingsToggle
          settingName="Hard Mode"
          flag={isHardMode}
          handleFlag={handleHardMode}
          description={HARD_MODE_DESCRIPTION}
        />
        <SettingsToggle
          settingName="Dark Mode"
          flag={isDarkMode}
          handleFlag={handleDarkMode}
        />
        <SettingsToggle
          settingName="High Contrast Mode"
          flag={isHighContrastMode}
          handleFlag={handleHighContrastMode}
          description={HIGH_CONTRAST_MODE_DESCRIPTION}
        />
        <div className="flex justify-between gap-4 py-3" onClick={() => window.open('https://forms.gle/b3iE57sMbGzMbPYD6')}>
          <div className="text-gray-500 dark:text-gray-300 mt-2 text-left">
            <p className="leading-none">Contact Us</p>
              <p className="text-xs mt-1 text-gray-500 dark:text-gray-300">
                Provide feedback or submit a word
              </p>
          </div>
        </div>
      </div>
    </BaseModal>
  )
}
